import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'localDate',
    standalone: false
})
export class LocalDatePipe implements PipeTransform {
    constructor() {}

    transform(value: string) {
        return this.convertUTCDateToLocalDate(new Date(value));
    }

    convertUTCDateToLocalDate(date: Date) {
        let newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
        let offset = date.getTimezoneOffset() / 60;
        let hours = date.getHours();

        newDate.setHours(hours - offset);

        return newDate;
    }

    convertDateToUTC(date: Date) {
        return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

    getLocalISOString(date: Date) {
        const offset = date.getTimezoneOffset();
        const offsetAbs = Math.abs(offset);
        const isoString = new Date(date.getTime() - offset * 60 * 1000).toISOString();

        return `${isoString.slice(0, -1)}${offset > 0 ? '-' : '+'}${String(Math.floor(offsetAbs / 60)).padStart(2, '0')}:${String(offsetAbs % 60).padStart(2, '0')}`
    }
}